import {
	type WalletComputedCurrencyConversionRates,
	type WalletCurrencyComputedConversionRatesRequest
} from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';

import { fetchConversionRates } from '../api/currencies';

/**
 * @params WalletCurrencyComputedConversionRatesRequest - [{ from: string; to: string;}]
 * @returns Currencies conversion rates
 */
export const useConversionRatesQuery = <TData = undefined | WalletComputedCurrencyConversionRates>(
	rates: Array<WalletCurrencyComputedConversionRatesRequest>,
	select?: (data: undefined | WalletComputedCurrencyConversionRates) => TData
) =>
	useQuery({
		enabled: Boolean(rates[0]?.from && rates[0]?.to),
		queryFn: () =>
			fetchConversionRates({
				rates
			}),
		queryKey: ['conversionRates', rates],
		select
	});
